export default __webpack_public_path__ + "content/media/linkvive.c66a02ee.png";